import React from 'react'
import { normalizeStatus, type NormalizedStatus } from '../../lib/status-utils'
import type { PodcastStatusValue } from '../../types/enums'
import Badge from './badge'

const statusToVariant: Record<NormalizedStatus, 'default' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'purple' | 'pink' | 'indigo'> = {
  Draft: 'default',
  Processing: 'warning',
  Completed: 'success',
  Failed: 'danger',
  Unknown: 'secondary',
}

export interface StatusBadgeProps {
  status: PodcastStatusValue
  className?: string
  titlePrefix?: string
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '', titlePrefix = '' }) => {
  const normalized = normalizeStatus(status)
  const variant = statusToVariant[normalized]
  const label = normalized
  const title = `${titlePrefix}${label}`.trim()

  return (
    <Badge
      variant={variant}
      className={className}
      title={title}
    >
      {label}
    </Badge>
  )
}

export default StatusBadge
